import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { id: 'page.agentactivity.title', defaultMessage: 'Agent activity' },
  intro: {
    id: 'page.agentactivity.intro',
    defaultMessage:
      'Every action AI agents took with your FileSpin access: the dashboard AI Agent, your scheduled agents, and apps such as Claude or ChatGPT. Prompts, search text and message content are never kept. Records are kept for 90 days.',
  },
  scopeMine: { id: 'page.agentactivity.scopemine', defaultMessage: 'My activity' },
  scopeAccount: { id: 'page.agentactivity.scopeaccount', defaultMessage: 'Whole account' },
  showingUser: { id: 'page.agentactivity.showinguser', defaultMessage: 'Showing {email}' },
  clear: { id: 'page.agentactivity.clear', defaultMessage: 'Clear' },

  period: { id: 'page.agentactivity.period', defaultMessage: 'Period' },
  last24h: { id: 'page.agentactivity.last24h', defaultMessage: 'Last 24 hours' },
  last7d: { id: 'page.agentactivity.last7d', defaultMessage: 'Last 7 days' },
  last30d: { id: 'page.agentactivity.last30d', defaultMessage: 'Last 30 days' },
  last90d: { id: 'page.agentactivity.last90d', defaultMessage: 'Last 90 days' },

  agentsTitle: { id: 'page.agentactivity.agentstitle', defaultMessage: 'Agents' },
  agentsHint: {
    id: 'page.agentactivity.agentshint',
    defaultMessage: 'Select an agent to see only its actions.',
  },
  agent: { id: 'page.agentactivity.agent', defaultMessage: 'Agent' },
  calls: { id: 'page.agentactivity.calls', defaultMessage: 'Actions' },
  errors: { id: 'page.agentactivity.errors', defaultMessage: 'Errors' },
  rejected: { id: 'page.agentactivity.rejected', defaultMessage: 'Refused' },
  errorRate: { id: 'page.agentactivity.errorrate', defaultMessage: 'Error rate' },
  totals: {
    id: 'page.agentactivity.totals',
    defaultMessage:
      '{calls, plural, one {# action} other {# actions}} by {agents, plural, one {# agent} other {# agents}} · {rate} errors',
  },
  viewActions: { id: 'page.agentactivity.viewactions', defaultMessage: 'View actions' },
  signOutApp: { id: 'page.agentactivity.signoutapp', defaultMessage: 'Sign out' },
  openSchedule: { id: 'page.agentactivity.openschedule', defaultMessage: 'Open schedule' },
  noAgents: {
    id: 'page.agentactivity.noagents',
    defaultMessage: 'No agent activity in this period.',
  },

  actionsTitle: { id: 'page.agentactivity.actionstitle', defaultMessage: 'Actions' },
  filterKind: { id: 'page.agentactivity.filterkind', defaultMessage: 'Agent type' },
  filterStatus: { id: 'page.agentactivity.filterstatus', defaultMessage: 'Result' },
  filterTool: { id: 'page.agentactivity.filtertool', defaultMessage: 'Action' },
  filterUser: { id: 'page.agentactivity.filteruser', defaultMessage: 'User' },
  any: { id: 'page.agentactivity.any', defaultMessage: 'Any' },
  allUsers: { id: 'page.agentactivity.allusers', defaultMessage: 'All users' },
  agentFilter: { id: 'page.agentactivity.agentfilter', defaultMessage: 'Agent: {name}' },

  kindDashboard: { id: 'page.agentactivity.kinddashboard', defaultMessage: 'Dashboard' },
  kindScheduled: { id: 'page.agentactivity.kindscheduled', defaultMessage: 'Scheduled' },
  kindExternal: { id: 'page.agentactivity.kindexternal', defaultMessage: 'External app' },
  kindApiKey: { id: 'page.agentactivity.kindapikey', defaultMessage: 'API key' },

  statusSuccess: { id: 'page.agentactivity.statussuccess', defaultMessage: 'Done' },
  statusError: { id: 'page.agentactivity.statuserror', defaultMessage: 'Error' },
  statusRejected: { id: 'page.agentactivity.statusrejected', defaultMessage: 'Refused' },

  colTime: { id: 'page.agentactivity.coltime', defaultMessage: 'When' },
  colAction: { id: 'page.agentactivity.colaction', defaultMessage: 'Action' },
  colTargets: { id: 'page.agentactivity.coltargets', defaultMessage: 'On' },
  colResult: { id: 'page.agentactivity.colresult', defaultMessage: 'Result' },
  colTook: { id: 'page.agentactivity.coltook', defaultMessage: 'Took' },
  colUser: { id: 'page.agentactivity.coluser', defaultMessage: 'User' },
  more: { id: 'page.agentactivity.more', defaultMessage: '+{count} more' },
  loadMore: { id: 'page.agentactivity.loadmore', defaultMessage: 'Load more' },
  exportCsv: { id: 'page.agentactivity.exportcsv', defaultMessage: 'Export CSV' },
  exportHint: {
    id: 'page.agentactivity.exporthint',
    defaultMessage: 'Exports the actions loaded below.',
  },
  noActions: {
    id: 'page.agentactivity.noactions',
    defaultMessage: 'No actions match these filters.',
  },
  loading: { id: 'page.agentactivity.loading', defaultMessage: 'Loading agent activity…' },
  loadError: {
    id: 'page.agentactivity.loaderror',
    defaultMessage: "Couldn't load agent activity. Try again in a moment.",
  },
  forbidden: {
    id: 'page.agentactivity.forbidden',
    defaultMessage: "You don't have permission to see this activity.",
  },
  targetAsset: { id: 'page.agentactivity.targetasset', defaultMessage: 'Asset' },
  targetCollection: { id: 'page.agentactivity.targetcollection', defaultMessage: 'Collection' },
  targetShare: { id: 'page.agentactivity.targetshare', defaultMessage: 'Share' },
  targetSchedule: { id: 'page.agentactivity.targetschedule', defaultMessage: 'Schedule' },
  targetJob: { id: 'page.agentactivity.targetjob', defaultMessage: 'Job' },
});
